export const decodeBase64CSV = (response: string): string => {
  try {
    if (!response) return "";
    return atob(response.replace(/\s/g, ""));
  } catch (e) {
    console.error("Base64 decode error:", e);
    return "";
  }
};

export const triggerCsvDownload = (csv: string, filename: string): void => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.download = filename;
  anchor.click();

  URL.revokeObjectURL(url);
};
